var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ],
      staticClass: "full_layout market",
      attrs: { id: "Market" }
    },
    [
      _c("div", { staticClass: "breadcrumbANDsort" }, [
        _c(
          "div",
          { staticClass: "breadcrumb" },
          [
            _c("router-link", { attrs: { to: { path: "/" } } }, [
              _vm._v(_vm._s(_vm.$t("Home")))
            ]),
            _vm._v(" "),
            _vm.fname != ""
              ? _c(
                  "router-link",
                  { attrs: { to: { path: "/market?f=" + _vm.fid } } },
                  [_vm._v(_vm._s(_vm.fname))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.sname != ""
              ? _c("span", [_vm._v(_vm._s(_vm.sname))])
              : _vm._e(),
            _vm._v(" "),
            _vm.searchTxt
              ? _c("span", [_vm._v(_vm._s(_vm.searchTxt))])
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "sort" }, [
          _c(
            "span",
            {
              class: { on: _vm.isSort == 0 },
              on: {
                click: function($event) {
                  return _vm.sort(0)
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("RecentlyAdded")))]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "sort_price",
              class: { on: _vm.isSort == 1 },
              on: {
                click: function($event) {
                  return _vm.sort(1)
                }
              }
            },
            [
              _vm._v("\n        " + _vm._s(_vm.$t("Price")) + "\n        "),
              _c("em", { staticClass: "up_arr", class: { up: _vm.isPrice } }),
              _vm._v(" "),
              _c("em", {
                staticClass: "up_down",
                class: { up: !_vm.isPrice && _vm.isPrice != null }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "sort_price",
              class: { on: _vm.isSort == 2 },
              on: {
                click: function($event) {
                  return _vm.sort(2)
                }
              }
            },
            [
              _vm._v(
                "\n        " + _vm._s(_vm.$t("BestSelling")) + "\n        "
              ),
              _c("em", { staticClass: "up_arr", class: { up: _vm.isVolume } }),
              _vm._v(" "),
              _c("em", {
                staticClass: "up_down",
                class: { up: !_vm.isVolume && _vm.isVolume != null }
              })
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "space_between" }, [
        _c("div", { staticClass: "productsClassBox" }, [
          _c(
            "div",
            { staticClass: "productsClass" },
            [
              _c("div", { staticClass: "productsClassTitle" }, [
                _vm._v(_vm._s(_vm.$t("Filter")))
              ]),
              _vm._v(" "),
              _vm.categorylist == 0
                ? _vm._l(_vm.category, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "CategoryLIst",
                        class: { up: _vm.categoryArray[index]["isType"] }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "CategoryTitle",
                            on: {
                              click: function($event) {
                                return _vm.listTransform(item.id, index)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(item.label) +
                                "\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "ul",
                          _vm._l(item.children, function(it, i) {
                            return _c("li", { key: i }, [
                              _c(
                                "span",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.MenuUserGo(
                                        "/market?f=" +
                                          it.Fid +
                                          "&s=" +
                                          it.id +
                                          "&search=" +
                                          _vm.searchTxt,
                                        "market"
                                      )
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(it.label))]
                              )
                            ])
                          }),
                          0
                        )
                      ]
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.property != null && _vm.categorylist != 0
                ? [
                    _c(
                      "div",
                      { staticClass: "productScreenBox" },
                      [
                        _c(
                          "el-collapse",
                          {
                            staticClass: "productCollapse",
                            model: {
                              value: _vm.openeds,
                              callback: function($$v) {
                                _vm.openeds = $$v
                              },
                              expression: "openeds"
                            }
                          },
                          _vm._l(_vm.property, function(item, index) {
                            return _c(
                              "el-collapse-item",
                              { key: index, attrs: { name: index + 1 } },
                              [
                                _c("template", { slot: "title" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$i18n.locale === "zh"
                                          ? item.Property.ChName
                                          : item.Property.ControlName ||
                                              item.Property.ChName
                                      ) +
                                      "\n                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "productCollapseList" },
                                  [
                                    _c(
                                      "el-checkbox-group",
                                      {
                                        staticClass: "productScreenCheckbox",
                                        on: {
                                          change: function($event) {
                                            return _vm.checkboxChange(
                                              _vm.checkList[
                                                item.Property.ControlName
                                              ],
                                              item.Property.ControlName
                                            )
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.checkList[
                                              item.Property.ControlName
                                            ],
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.checkList,
                                              item.Property.ControlName,
                                              $$v
                                            )
                                          },
                                          expression:
                                            "checkList[item.Property.ControlName]"
                                        }
                                      },
                                      _vm._l(item.PropertyKeyValues, function(
                                        it,
                                        j
                                      ) {
                                        return _c(
                                          "div",
                                          { key: j },
                                          [
                                            _c(
                                              "el-checkbox",
                                              { attrs: { label: it.ChName } },
                                              [_vm._v(_vm._s(it.ChName))]
                                            )
                                          ],
                                          1
                                        )
                                      }),
                                      0
                                    )
                                  ],
                                  1
                                )
                              ],
                              2
                            )
                          }),
                          1
                        )
                      ],
                      1
                    )
                  ]
                : _vm._e()
            ],
            2
          )
        ]),
        _vm._v(" "),
        !_vm.isNull
          ? _c(
              "div",
              { staticClass: "productsListBox" },
              [
                _vm.list != null
                  ? _c("div", { ref: "ball", staticClass: "ball" })
                  : _vm._e(),
                _vm._v(" "),
                _vm.list != null
                  ? _c(
                      "ul",
                      { staticClass: "products" },
                      _vm._l(_vm.list, function(item, index) {
                        return _c(
                          "li",
                          { key: index, class: { presale: item.Presale == 1 } },
                          [
                            item.Status == 2
                              ? _c("i", { class: "lang-" + _vm.$i18n.locale })
                              : _vm._e(),
                            _vm._v(" "),
                            item.Presale == 1
                              ? _c("i", { class: "lang-" + _vm.$i18n.locale })
                              : _vm._e(),
                            _vm._v(" "),
                            item.QuantitySold <= 0
                              ? _c("div", { staticClass: "outOfStock" }, [
                                  _vm._v(_vm._s(_vm.$t("OutofStock")))
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userInfo != null &&
                            item.QuantitySold > 0 &&
                            item.Presale != 1
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "addCart",
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.toCart($event, item)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("AddtoCart")))]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    path:
                                      "/market/item/" +
                                      item._id +
                                      "?type=" +
                                      (_vm.fname != "" && _vm.sname != ""
                                        ? "0"
                                        : "1")
                                  }
                                }
                              },
                              [
                                _c("div", { staticClass: "imgBox" }, [
                                  _c("img", {
                                    attrs: {
                                      src: item.TitImg + "?imageView2/2/w/238"
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "line_txt3 productsText" },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(item.Title) +
                                        "\n            "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.isShowPrice(item)
                                  ? _c(
                                      "div",
                                      { staticClass: "productsPrice" },
                                      [
                                        _vm._v(
                                          _vm._s(item.Price.toLocaleString())
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ],
                          1
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.list != null
                  ? _c("pagination", {
                      attrs: { TotalCount: _vm.TotalCount, ps: _vm.ps },
                      on: { ps: _vm.pageSize, pi: _vm.pageIndex }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isNull
          ? _c(
              "div",
              { staticClass: "productsListBox" },
              [
                _c("nonull", {
                  attrs: { type: "item", text: _vm.$t("Nofound") }
                })
              ],
              1
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-50481c43", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50481c43","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/market/index.vue
// module id = null
// module chunks = 